import { useState } from "react"
import { SolicitudesYRegistros } from "./SolicitudesYRegistros";
import { formatFechaVisual } from "../../js/functions";
import { crearRegistro, eliminarSolicitud, updateRegistro } from "../../firebase/firebase";

export function Solicitud({ user, solicitud, registro, admin }) {

  const [display, setDisplay] = useState("none");

  function onChangeDisplay() {
    if (display === "none") setDisplay("table-row")
    else setDisplay("none")
  }

  function onClickRechazarCambios() {
    eliminarSolicitud(solicitud.datosTrabajador.id)
  }

  async function onClickAceptarCambios() {
    const solicitudParaActualizar = { ...solicitud }
    if (solicitudParaActualizar.nombreAdminCambioInicio === "NOMBRE_ADMIN") {
      solicitudParaActualizar.nombreAdminCambioInicio = user.name
      solicitudParaActualizar.fechaCambioInicio = new Date()
      solicitudParaActualizar.motivoSolicitudInicio = solicitud.motivoSolicitudInicio
    } 
    if (solicitudParaActualizar.nombreAdminCambioFin === "NOMBRE_ADMIN") {
      solicitudParaActualizar.nombreAdminCambioFin = user.name
      solicitudParaActualizar.fechaCambioFin = new Date()
      solicitudParaActualizar.motivoSolicitudFin = solicitud.motivoSolicitudFin
    } 
    if (solicitudParaActualizar.pausas !== undefined && solicitudParaActualizar.pausas !== null) {
      solicitudParaActualizar.pausas.forEach((pausa, index) => {
        if (pausa.nombreAdminCambioPausa === "NOMBRE_ADMIN") {
          pausa.nombreAdminCambioPausa = user.name
          pausa.fechaCambioPausa = new Date()
          pausa.motivoSolicitudPausa = solicitud.pausas[index].motivoSolicitudPausa
        } 
      })
    }

    try {
      await crearRegistro(solicitud.datosTrabajador.uid, solicitud.datosTrabajador.fecha, solicitudParaActualizar)
      await eliminarSolicitud(solicitud.datosTrabajador.id)
    } catch (error) {
      console.error("Error al aceptar la solicitud ->", error);
    }
  }

  return (
    <>
      <tr className="alturaColumna">
        <td>{solicitud.datosTrabajador.name}</td>
        <td>{solicitud.datosTrabajador.email}</td>
        <td>{formatFechaVisual(solicitud.fecha)}</td>
        <td className="textright"><button className="secondaryButton" onClick={onChangeDisplay}>Ver_cambios</button></td>
      </tr>
      <tr>
        <td colSpan={4}>
          <strong>Motivo solicitud</strong> → {solicitud.datosTrabajador.motivoSolicitud}
        </td>
      </tr>
      <tr style={{display: display}}>
        <td colSpan={4} style={{ height: "10px" }} />
      </tr>
      <tr style={{display: display}}>
        <td colSpan={4}>
          <SolicitudesYRegistros solicitud={solicitud} registro={registro} />
        </td>
      </tr>
      <tr className="textright" style={{display: display}}>
        <td colSpan={4}>
          {admin === true && 
            <>
              <button onClick={onClickRechazarCambios} className="cancelButton marginright-8" >Rechazar cambios</button>
              <button onClick={onClickAceptarCambios} className="acceptButton" >Aceptar cambios</button>
            </>
          }
          {admin === false && 
            <>
              <button onClick={onClickRechazarCambios} className="cancelButton marginright-8" >Borrar solicitud</button>
            </>
          }
          
        </td>
      </tr>
      <tr>
        <td colSpan={4}><hr /></td>
      </tr>
    </>
  );
}